/**
 * Thai Language Translations
 */

export default {
  uploadHistory: {
    title: 'ประวัติการอัปโหลด CSV',
    subtitle: 'ติดตามและตรวจสอบประวัติการนำเข้าข้อมูล',

    // Actions
    back: 'กลับ',
    refresh: 'รีเฟรช',
    search: 'ค้นหา',
    viewDetails: 'ดูรายละเอียด',
    clearAll: 'ล้างทั้งหมด',

    // Statistics
    stats: {
      totalUploads: 'การอัปโหลดทั้งหมด',
      successful: 'สำเร็จ',
      partial: 'สำเร็จบางส่วน',
      failed: 'ล้มเหลว',
      items: 'รายการ',
      ofTotal: 'ของทั้งหมด',
    },

    // Filter Section
    filter: {
      title: 'ค้นหาและกรองข้อมูล',
      subtitle: 'ค้นหาและกรองประวัติการอัปโหลดของคุณ',
      searchPlaceholder: 'ชื่อไฟล์, ผู้อัปโหลด, เลขที่เอกสาร',
      status: 'สถานะ',
      template: 'Template',
      date: 'วันที่',
      filterBy: 'กรองโดย:',
      clearFilters: 'ล้างการค้นหา',
    },

    // Table
    table: {
      title: 'รายการประวัติการอัปโหลด',
      showing: 'แสดงทั้งหมด',
      items: 'รายการ',

      headers: {
        dateTime: 'วันที่/เวลา',
        uploadedBy: 'ผู้อัปโหลด',
        file: 'ไฟล์',
        template: 'Template',
        status: 'สถานะ',
        counts: 'จำนวน',
        duration: 'เวลา',
        actions: 'จัดการ',
      },
    },

    // Status
    status: {
      all: 'ทั้งหมด',
      processing: 'กำลังประมวลผล',
      completed: 'สำเร็จ',
      completedWithErrors: 'สำเร็จบางส่วน',
      failed: 'ล้มเหลว',
    },

    // Template
    template: {
      all: 'ทั้งหมด',
      template1: 'Template 1',
      template2: 'Template 2',
    },

    // Empty State
    empty: {
      title: 'ไม่พบข้อมูล',
      noData: 'ยังไม่มีประวัติการอัปโหลด CSV',
      noResults: 'ไม่พบผลลัพธ์ที่ตรงกับการค้นหา',
    },

    // Loading
    loading: {
      title: 'กำลังโหลดข้อมูล',
      subtitle: 'กรุณารอสักครู่...',
    },

    // Counts
    counts: {
      total: 'รวม',
      items: 'รายการ',
      success: 'สำเร็จ',
      failed: 'ล้มเหลว',
    },

    // Duration
    duration: {
      seconds: 'วินาที',
    },

    // File Info
    file: {
      notAvailable: 'N/A',
      encoding: 'การเข้ารหัส',
    },

    // Messages
    messages: {
      refreshSuccess: 'รีเฟรชข้อมูลสำเร็จ',
      loadFailed: 'ไม่สามารถโหลดประวัติการอัปโหลดได้',
      reason: 'สาเหตุ',
      filterCleared: 'ล้างตัวกรองทั้งหมดแล้ว',
    },

    // Accessibility
    a11y: {
      backButton: 'กลับไปหน้าเอกสาร',
      refreshButton: 'รีเฟรชข้อมูลประวัติการอัปโหลด',
      searchField: 'ค้นหาประวัติการอัปโหลด',
      statusFilter: 'กรองตามสถานะ',
      templateFilter: 'กรองตาม Template',
      dateFilter: 'กรองตามวันที่',
      viewDetailsButton: 'ดูรายละเอียดการอัปโหลด',
      closeDialog: 'ปิดหน้าต่าง',
      clearFilter: 'ล้างตัวกรอง',
    },
  },
};
